import React from 'react';
import { makeStyles } from '@material-ui/core';
import { COLOR_BLACK, COLOR_WHITE } from '../../../../colors';
import AreaFeature from './AreaFeature';

const useStyles = makeStyles((theme)=> ({
    areaInfographicWrap: {
        position: 'absolute',
        top: 30,
        right: 0,
        height: 472,
        width: 513,
        color: COLOR_BLACK,
        fontFamily: ['"LL Circular Pro"', 'Arial', 'Helvetica', 'sans-serif'],
    },
    relativeDiv: {
        position: 'relative',
        width: '100%',
        height: '100%',
    },
    walkPathTop: {
        position: 'absolute',
        top: 50,
        right: 7,
        height: 180,
        width: 450,
        border: `4px solid ${COLOR_BLACK}`,
        borderRadius: '0 50px 50px 0',
        borderLeftColor: 'transparent',
    },
    contractWalkPathTop: {
        width: 424,
    },
    walkPathBottom: {
        position: 'absolute',
        top: 234,
        left: 0,
        height: 180,
        width: 450,
        border: `4px solid ${COLOR_BLACK}`,
        borderRadius: '50px 0 0 50px',
        borderRightColor: 'transparent',
    },
    contractWalkPathBottom: {
        width: 424,
        left: 32,
    },
    exploreNearbyPill: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: 204,
        height: 104,
        backgroundRepeat: 'no-repeat',
        backgroundImage: 'url("./images/ListingShareable/map-pin-pill.svg")',
    },
    exploreNearby: {
        marginTop: 24,
        marginLeft: 80,
        width: 94,
    },
    getInTouchPill: {
        position: 'absolute',
        bottom: 0,
        right: 0,
        width: 277,
        height: 104,
        backgroundRepeat: 'no-repeat',
        backgroundImage: 'url("./images/ListingShareable/get-in-touch-pill.svg")',
    },
    getInTouch: {
        marginTop: 24,
        marginLeft: 41,
        width: 224,
    },
    ctaText: {
        fontSize: '26px',
        lineHeight: '28px',
        fontWeight: 800,
    },
}));


const useAnimationStyles = makeStyles((theme)=> ({
    exploreNearbyPill: {
        backgroundImage: 'url("./images/ListingShareable/map-pin-pill-dark.svg")',
        color: COLOR_WHITE,
    },
    getInTouchPill: {
        backgroundImage: 'url("./images/ListingShareable/get-in-touch-pill-dark.svg")',
        color: COLOR_WHITE,
    }
}));

export function AreaInfographic({
    currentFrame,
    keyframeInterval,
    lastKeyframe,
    area,
    isContractLayout,
}) {
    const classes = useStyles();
    const animationClasses = useAnimationStyles();
    return (
        <div className={classes.areaInfographicWrap}>
            <div className={classes.relativeDiv}>

                {/* Walking Path Stroke */}

                <div className={`${classes.walkPathTop} ${isContractLayout && classes.contractWalkPathTop}`}></div>
                <div className={`${classes.walkPathBottom} ${isContractLayout && classes.contractWalkPathBottom}`}></div>

                {/* Explore Nearby */}

                <div className={`${classes.exploreNearbyPill} ${currentFrame > keyframeInterval ? animationClasses.exploreNearbyPill : ''}`}>
                    <div className={classes.relativeDiv}>
                        <div className={`${classes.exploreNearby} ${classes.ctaText}`}>
                            Explore Nearby
                        </div>
                    </div>
                </div>

                {/* Area Features */}
                {area && (
                    area
                        .slice(0, 6)
                        .map((feature, i)=>  (
                        <AreaFeature
                            key={`feature_block_${feature.category}_${i}`}
                            feature={feature}
                            index={i}
                            keyframeInterval={keyframeInterval}
                            currentFrame={currentFrame}
                        />
                    ))
                )}

                {/* Get in touch */}

                <div className={`${classes.getInTouchPill} ${currentFrame >= lastKeyframe ? animationClasses.getInTouchPill : ''}`}>
                    <div className={classes.relativeDiv}>
                        <div className={`${classes.getInTouch} ${classes.ctaText}`}>
                            Get in touch with
                            me for more info!
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}